// Carrega uma tela sob demanda (o arquivo da tela só é baixado quando ela é aberta).
// Se o arquivo não existir mais — o site foi atualizado enquanto a aba estava aberta —,
// recarrega a página uma vez para pegar a versão nova. Se ainda assim falhar, mostra
// um aviso no lugar da tela (em vez de deixar a página em branco).
import React, { lazy } from "react";

const FLAG = "g17_chunk_reload";

function LoadError() {
  return (
    <div style={{ padding: "3rem 1.5rem", textAlign: "center", opacity: 0.85 }}>
      <p style={{ margin: "0 0 1rem", fontWeight: 700 }}>Não foi possível carregar esta tela.</p>
      <button onClick={() => window.location.reload()} style={{ padding: "0.6rem 1.4rem", borderRadius: 8, cursor: "pointer", fontWeight: 700 }}>
        Recarregar a página
      </button>
    </div>
  );
}

export function lazyScreen(load, name) {
  return lazy(() => load().then(
    m => {
      try { sessionStorage.removeItem(FLAG); } catch {}
      return { default: m[name] };
    },
    err => {
      let already = false;
      try { already = sessionStorage.getItem(FLAG) === "1"; } catch {}
      if (!already) {
        try { sessionStorage.setItem(FLAG, "1"); } catch {}
        window.location.reload();
        return new Promise(() => {});        // a página vai recarregar
      }
      console.error("Falha ao carregar a tela " + name + ":", err);
      return { default: LoadError };
    }
  ));
}
